"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Image from "next/image"
import map from "lodash/map"
import styles from "./styles.module.scss"
import fullTapePic from "./shared/images/full-tape.png"
import Header from "../shared/Header"
import SectionContainer from "../shared/SectionContainer"
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import {
  PRIMARY_BLACK_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../shared/constants"
import { TAPE_LINE_ITEMS } from "./shared/constants"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"

function HowItWorks() {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()

  const renderHeader = () => {
    return <Header text="How it works" />
  }

  const renderButtons = () => {
    return (
      <PrimaryAndSecondaryButtonsContainer
        button1={{
          type: PRIMARY_BLACK_BUTTON_TYPE,
          text: "Run your group",
          href: getRouteForLeaderOnboarding(),
        }}
        button2={{
          type: SECONDARY_BUTTON_TYPE,
          text: "Get monthly listings",
          onClick: async () => {
            getMonthlyListingsClickHandler()
          },
        }}
      />
    )
  }

  const renderTapeHeader = ({
    title,
    extraStyles,
  }: {
    title: string
    extraStyles?: string
  }) => {
    return (
      <h2
        className={`min-[600px]:pt-0 pt-[20px] ${styles["title"]} ${extraStyles ? extraStyles : ""}`}
      >
        {title}
      </h2>
    )
  }

  const renderTapeDescirption = ({ description }) => {
    return <div className={styles["description"]}>{description}</div>
  }

  const renderTapeNumber = ({ lineNumber }) => {
    return <div className={styles["tape-number"]}>{lineNumber}</div>
  }

  const renderTape = ({ title, description, lineNumber }) => {
    return (
      <div className={styles["tape-container"]}>
        <div className={styles["not-mobile"]}>
          {renderTapeNumber({ lineNumber })}
        </div>
        <div className={`flex flex-col m-10px min-[600px]:m-[30px_30px_20px_20px]`}>
          {/* <div className={styles["not-mobile"]}> */}
          {renderTapeHeader({ title, extraStyles: styles["not-mobile"] })}
          {/* </div> */}
          {renderTapeDescirption({ description })}
        </div>
      </div>
    )
  }

  const renderPicture = ({ pictureSrc, title }) => {
    return (
      <div className={styles["picture-container"]}>
        <Image
          src={pictureSrc}
          height={125}
          width={125}
          className={styles["grayscale"]}
          alt={`how it works ${title}`}
        />
      </div>
    )
  }

  const renderBackgroundTape = () => {
    return (
      <div className={styles["tape-background-container"]}>
        <div
          className={`relative h-full w-[calc(100%-63px)] ml-0 z-index-5 min-[600px]:ml-[63px] ${styles["full-tape"]}`}
        >
          <Image src={fullTapePic} alt={"full tape"} fill={true} />
        </div>
      </div>
    )
  }
  const renderMobileTapeNumberAndTitle = ({ lineNumber, title }) => {
    return (
      <div className={styles["tape-title-number-mobile"]}>
        {renderTapeNumber({ lineNumber })}
        {renderTapeHeader({ title })}
      </div>
    )
  }

  const renderPicAndTapeLine = ({
    pictureSrc,
    lineNumber,
    title,
    description,
    index,
  }) => {
    return (
      <div
        className={styles["pic-and-tape-container-outer"]}
        key={`how-it-works-pic-${index}`}
      >
        {renderMobileTapeNumberAndTitle({ lineNumber, title })}
        <div className={styles["pic-and-tape-container"]}>
          {renderPicture({ pictureSrc, title })}
          {renderTape({ lineNumber, title, description })}
          {renderBackgroundTape()}
        </div>
      </div>
    )
  }

  const renderPicAndTapeLines = () => {
    return map(
      TAPE_LINE_ITEMS,
      ({ pictureSrc, lineNumber, title, description }, index) => {
        return renderPicAndTapeLine({
          pictureSrc,
          lineNumber,
          title,
          description,
          index,
        })
      },
    )
  }

  return (
    <SectionContainer>
      {renderHeader()}
      {renderPicAndTapeLines()}
      {renderButtons()}
    </SectionContainer>
  )
}
export default HowItWorks
